'use client';

import React, { useEffect, useRef, useState } from 'react';
import StickyCTA from './StickyCTA';

const SAFARI_MOV_URL =
  'https://lmqcf863oblapye9.public.blob.vercel-storage.com/otter-down2.mov';

export default function OtterCTA() {
  const [hasScrolled, setHasScrolled] = useState(false);
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const onScroll = () => {
      if (window.scrollY > 50) {
        setHasScrolled(true);
        window.removeEventListener('scroll', onScroll);
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    if (!hasScrolled || !videoRef.current) return;
    // Nudge autoplay once visible on iOS
    videoRef.current.play().catch(() => {});
  }, [hasScrolled]);

  const handleVideoEnd = () => {
    if (videoRef.current) videoRef.current.pause();
  };

  return (
    <div
      className="fixed bottom-0 right-0 z-50 w-40 h-40 sm:w-56 sm:h-56 md:w-80 md:h-80"
      style={{ pointerEvents: 'none' }}
    >
      {hasScrolled && (
        <video
          ref={videoRef}
          autoPlay
          muted
          loop
          playsInline
          preload="metadata"
          onEnded={handleVideoEnd}
          // Visible on all breakpoints. Size scales with container.
          className="absolute bottom-1 right-2 sm:bottom-2 sm:right-3 md:bottom-2 md:right-4 z-10 w-36 sm:w-48 md:w-72 h-auto"
          style={{ pointerEvents: 'none', filter: 'brightness(1.5)' }}
        >
          {/* Safari (alpha) */}
          <source
            src={SAFARI_MOV_URL}
            type='video/quicktime; codecs="hvc1"'
          />
          {/* Chrome/Firefox (alpha) */}
          <source
            src="/wet/otter-down.webm"
            type='video/webm; codecs="vp9"'
          />
        </video>
      )}

      {/* CTA stays clickable on all screens */}
      <StickyCTA className="glow-button absolute bottom-3 right-4 sm:bottom-4 sm:right-6 md:bottom-6 md:right-10 z-20 pointer-events-auto" />
    </div>
  );
}
